import _ from 'lodash';
import CalculatedVolumeDiscount from 'src/entities/cart/response/CalculatedVolumeDiscount';
import ShoppingCart from 'src/entities/cart/response/ShoppingCart';
import { getEntities } from 'src/store/entities/selectors';
import { EntityDescriptions } from 'src/store/entities/types';
import { SingleEntityState } from 'src/store/entities/types/SingleEntityState';

export interface ShoppingCartEntityState extends Omit<SingleEntityState<ShoppingCart>, 'content'> {
    content: ShoppingCart;
}

/**
 * Selects the shopping cart from the global redux store
 * and creates an appropriate class object of it
 */
export const getShoppingCart = (state: any): ShoppingCartEntityState => {
    const cart = state.cart;
    if (_.isEmpty(cart)) return shoppingCartDefaultState();

    return {
        isFetching: cart.isFetching,
        error: cart.error,
        content: cart.content ? createNewShoppingCart(cart.content) : newEmptyCart(),
    };
};

const createNewShoppingCart = (cart: any) => {
    return new ShoppingCart(cart);
};

const newEmptyCart = () => {
    return ShoppingCart.emptyCart();
};

export const getCalculatedVolumeDiscounts = (state: any): CalculatedVolumeDiscount[] => {
    const cart = getShoppingCart(state);
    if (!cart.content) return [];

    // select volume discounts from store
    const volumeDiscounts = getEntities(state, EntityDescriptions.VOLUME_DISCOUNT);

    // calculate discounts for current shopping cart
    return cart.content.getCalculatedVolumeDiscounts(volumeDiscounts.items);
};

export function shoppingCartDefaultState(): ShoppingCartEntityState {
    return {
        isFetching: false,
        error: undefined,
        content: newEmptyCart(),
    };
}
